import React from 'react';
import './SkeletonLoaderPopularTutor.css';

const SkeletonLoaderPopularTutor = () => {
  return (
    <section className="popular-mentor-skeleton">
      <div className="container">
        {/* Section Heading Skeleton */}
        <div className="heading-skeleton">
          <div className="skeleton-heading-icon" />
          <div className="skeleton-heading-text" />
          <div className="skeleton-heading-icon" />
        </div>

        {/* Skeleton Carousel */}
        <div className="skeleton-carousel">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="skeleton-card">
              <div className="skeleton-card-img" />
              <div className="skeleton-card-body">
                <div className="skeleton-title" />
                <div className="skeleton-subtitle" />
                <div className="skeleton-paragraph" />
                <div className="skeleton-paragraph short" />
                <div className="skeleton-button" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkeletonLoaderPopularTutor;
